export function getActiveTempScopes(
  temporaryPermissions: { expiry: string; scopes: string[] } | null | undefined,
): string[] {
  if (!temporaryPermissions?.expiry) return [];
  if (new Date(temporaryPermissions.expiry) <= new Date()) return [];
  return temporaryPermissions.scopes ?? [];
}
